import { configureStore } from "@reduxjs/toolkit";
import fleetReducer from "./Fleet/FleetSlice";
import AppReducer from "./Auth/AuthSlice";
import vendorReducer from "./Vendor/VendorSlice";
import GlobalReducer from "./Global/GlobalSlice";
import assetReducer from "./Assets/AssetSlice";
import procurementReducer from "./Procurement/ProcurementSlice";
import dashboardReducer from "./Dashboard/DashboardSlice";
import assetSetUpReducer from "./AssetsSetUp/AssetSetUpSlice";
import consummableReducer from "./Consumables/ConsumablesSlice";
import permissionReducer from "./Permission/PermissionSlice";
import consummableSetUpReducer from "./ConsummableSetUp/ConsummableSetUpSlice";
import hrReducer from "./HR/HRSlice";
import reportReducer from "./Report/ReportSlice";
import employeeReducer from "./Employee/EmployeeSlice";
import PaymentServiceReducer from "./Finance/PaymentService/PaymentServiceSlice";
import AccountSetupSliceReducer from "./Finance/AccountingSetup/AccountingSetupSlice";
import CostCenterSlice from "./Finance/CostCenterSlice/CostCenterSlice";
import AssetNBVSlice from "./Finance/AssetNBVSlice/AssetNBVSlice";
import PayrollSlice from "./Finance/PayrollSlice/PayrollSlice";
import CooperativeSetupSlice from "./Finance/CooperativeSetup/CooperativeSetupSlice";
import AnalyseCompanyFundSlice from "./Finance/AnalyseCompanyFund/AnalyseCompanyFundSlice";
import BudgetImportSlice from "./Finance/BudgetImport/BudgetImportSlice";
import PaymentSetupSlice from "./Finance/PaymentSetup/PaymentSetupSlice";
import CooperativeManagementSlice from "./Finance/CooperativeManagement/CooperativeManagementSlice";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { payrollApi } from "../../app/api";
import { costCenterApi } from "../../app/api/costCenterApi";
import payrollReducer from "./Finance/PayrollSlice";
import { financeApi } from "../../app/api/financeApi";
import { vendorApi } from "../../app/api/vendorApi";
import { nlpcApi } from "../../app/api/nlpcApi";
import { hrApi } from "../../app/api/hrApi";
import { documentApi } from "../../app/api/documentApi";
import { controlServiceApi } from "../../app/api/controlApi";
import { employeeApi } from "../../app/api/employeeApi";
import NonStatutoryAdviceSlice from "./Finance/NonStatutoryAdviceManagement/NonStatutoryAdviceSlice";

const store = configureStore({
  reducer: {
    global: GlobalReducer,
    auth: AppReducer,
    vendor: vendorReducer,
    assets: assetReducer,
    assetSetUp: assetSetUpReducer,
    consummableSetUp: consummableSetUpReducer,
    consumable: consummableReducer,
    procurement: procurementReducer,
    dashboard: dashboardReducer,
    permissions: permissionReducer,
    hr: hrReducer,
    fluelRequest: fleetReducer,
    fleet: fleetReducer,
    report: reportReducer,
    employee: employeeReducer,
    paymentService: PaymentServiceReducer,
    accountLedgerSetup: AccountSetupSliceReducer,
    // hr,
    costCenterService: CostCenterSlice,
    assetStore: AssetNBVSlice,
    costCenter: CostCenterSlice,
    payrollStore: PayrollSlice,
    CooperativeSetup: CooperativeSetupSlice,
    companyFund: AnalyseCompanyFundSlice,
    BudgetImport: BudgetImportSlice,
    paymentSetup: PaymentSetupSlice,
    CooperativeManagement: CooperativeManagementSlice,
    nonStatutoryAdviceManagement: NonStatutoryAdviceSlice,
    [payrollApi.reducerPath]: payrollApi.reducer,
    [costCenterApi.reducerPath]: costCenterApi.reducer,
    [financeApi.reducerPath]: financeApi.reducer,
    [vendorApi.reducerPath]: vendorApi.reducer,
    [hrApi.reducerPath]: hrApi.reducer,
    [nlpcApi.reducerPath]: nlpcApi.reducer,
    [documentApi.reducerPath]: documentApi.reducer,
    [controlServiceApi.reducerPath]: controlServiceApi.reducer,
    [employeeApi.reducerPath]: employeeApi.reducer,
    payroll: payrollReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      payrollApi.middleware,
      costCenterApi.middleware,
      financeApi.middleware,
      vendorApi.middleware,
      nlpcApi.middleware,
      hrApi.middleware,
      documentApi.middleware,
      controlServiceApi.middleware,
      employeeApi.middleware,
    ]),
});
setupListeners(store.dispatch);
export default store;
